import { IBatch } from '../../../models/batches';
import '../../../themes/batch.css';
import { Card } from './Card';

interface Props {
    batchesGrouped: IBatch[]
}
export const ListCard = ({ batchesGrouped }: Props) => {
    return (
        <div className="card-container">
            {batchesGrouped.map((batch, index) => (
                <Card key={index} title={batch.masterActivity ?? ""} batches={batch.details} />
            ))}
        </div>
    );
};
